<template>
  <b-card no-body class="overflow-hidden card-container h-100 shadow-sm" style="border-radius: 8px; border: 1px solid #eaeaea;">
    <b-row no-gutters class="h-100 align-items-center">
      <b-col md="4" class="image-container h-100">
        <div
          class="card-image"
          :style="{ backgroundImage: 'url(' + imagenBase + ')' }"
          role="img"
          :aria-label="titulo"
        ></div>
      </b-col>
      <b-col md="8" class="h-100">
        <b-card-body :title="titulo.toUpperCase()" class="body-container h-100 d-flex flex-column justify-content-center">
          <b-card-text class="flex-grow-1">
            {{ this.firstLetterToUpperCase(resumen) }}
          </b-card-text>
          <b-button @click="$router.push({ name: 'detalle_articulo', params: { id: id } })" variant="primary" style="width: 200px; margin: 0px auto;" >{{
            $t("messages.readMore")
          }}</b-button>
        </b-card-body>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { Helpers } from "@/mixins/Helpers";
export default {
  mixins: [Helpers],
  props: {
    titulo: {
      type: String,
      default: "",
    },
    ultimaActualizacion: {
      type: String,
      default: "",
    },
    resumen: {
      type: String,
      default: "",
    },
    id: {
      type: Number,
      default: 0,
    },
    imagenBase: {
      type: String,
      default: "",
    },
  },
  methods: {
    formatDate(fecha) {
      return new Date(fecha).toLocaleDateString("en-GB");
    },
  },
};
</script>

<style scoped>
.card-container {
  width: 100%;
  margin: 0;
  height: 100%;
}
.image-container {
  padding: 0px;
  min-height: 220px;
}
.card-image {
  width: 100%;
  height: 100%;
  min-height: 220px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.body-container {
  height: fit-content;
  min-height: calc(100%);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
